export enum AppRoutes {
  WASTEDASHBOARD = "/wastemanagement/dashboard",
  WASTEDASHBOARDBINOVERVIEW = "/wastemanagement/dashboard/bin-overview",
  WASTEDASHBOARDWASTECOLLECTION = "/wastemanagement/dashboard/waste-collection",
  WASTEDASHBOARDWASTECOLLECTIONTYPE = "/wastemanagement/dashboard/waste-collection-type",
  WASTEDASHBOARRDDIC = "/wastemanagement/dashboard/dic",
  WASTEREPORT = "/wastemanagement/reportsummary",
  FEEDBACKCHAT = "/wastemanagement/chat/ui/feedback",
  SENSORCHAT = "/wastemanagement/chat/ui/sensor",
  CHATDASHBOARD = "/wastemanagement/chat/ui",
  CHATDASHBOARDLAYOUT = "/wastemanagement/chat",
  WASTEREPORTBINOVERVIEW = "/wastemanagement/reportsummary/bin-overview",
  WASTEREPORTWASTECOLLECTION = "/wastemanagement/reportsummary/waste-collection",
  WASTEREPORTDICREPORT = "/wastemanagement/reportsummary/dic-report",
  WASTEPREDICTIVEMAINTENCE = "/wastemanagement/maintenance",
  WASTEPREDICTIVEMAINTENCEASSET = "/wastemanagement/maintenance/asset-overview",
  WASTEPREDICTIVEMAINTENCESERVICESCHEDULE = "/wastemanagement/maintenance/service-schedule-timeline",
  WASTESUBSCRIBEFEATURES = "/wastemanagement/subscribe",
  WASTESUBSCRIBEADDMULTIPLEDEVICE = "/wastemanagement/subscribe/add-multiple-device",
  WASTESUBSCRIBEIMPACTANALYSIS = "/wastemanagement/subscribe/impact-analysis",
  INFRADASHBOARD = "/infra/dashboard",
  INFRADASHBOARDCORROSIONDETECTION = "/infra/dashboard/corrosion-detection",
  INFRADASHBOARDLEAKDETECTION = "/infra/dashboard/leak-detection",
  INFRADASHBOARDCRACKDETECTION = "/infra/dashboard/crack-detection",
  INFRADASHBOARDOPENCLOSEDETECTION = "/infra/dashboard/detection-type",
  INFRAREPORT = "/infra/reportsummary",
  INFRAREPORTCORROSIONDETECTION = "/infra/reportsummary/corrosion-detection",
  INFRAREPORTLEAKDETECTION = "/infra/reportsummary/leak-detection",
  INFRAREPORTCRACKDETECTION = "/infra/reportsummary/crack-detection",
  INFRAMAINTENANCE = "/infra/maintenance",
  INFRAMAINTENANCEASSETOVERVIEW = "/infra/maintenance/asset-overview",
  INFRAMAINTENANCESERVICESCHEDULETIMELINE = "/infra/maintenance/service-schedule-timeline",
  INFRASUBSCRIBEFEATURES = "/infra/subscribe",
  INFRASUBSCRIBEFEATUREADDDEVICE = "/infra/subscribe/add-multiple-device",
  INFRASUBSCRIBEIMPACTANALYSIS = "/infra/subscribe/impact-analysis",
  AGRIDASHBOARD = "/agriculture/dashboard",
  AGRIDASHBOARDGROWTHMONITORING = "/agriculture/dashboard/growth-monitoring",
  AGRIDASHBOARDANOMALYDETECTION = "/agriculture/dashboard/anomaly-detection",
  AGRIDASHBOARDPESTDETECTION = "/agriculture/dashboard/pest-detection",
  AGRIDASHBOARDDISEASEDETECTION = "/agriculture/dashboard/disease-detection",
  AGRIREPORT = "/agriculture/reportsummary",
  AGRIREPORTGROWTHMONITORING = "/agriculture/reportsummary/growth-monitoring",
  AGRIREPORTANOMALYDETECTION = "/agriculture/reportsummary/anomaly-detection",
  AGRIREPORTPESTDETECTION = "/agriculture/reportsummary/pest-detection",
  AGRIREPORTDISEASEDETECTION = "/agriculture/reportsummary/disease-detection",
  AGRIMAINTENANCE = "/agriculture/maintenance",
  AGRIMAINTENANCEGROWTHMONITORING = "/agriculture/maintenance/growth-monitoring",
  AGRIMAINTENANCESERVICESCHEDULETIMELINE = "/agriculture/maintenance/service-schedule-timeline",
  AGRISUBSCRIBEFEATURES = "/agriculture/subscribe",
  AGRISUBSCRIBEFEATUREADDDEVICE = "/agriculture/subscribe/add-multiple-device",
  AGRISUBSCRIBEIMPACTANALYSIS = "/agriculture/subscribe/impact-analysis",
  DASHBOARDINSIGHTS = "/dashboard/insights",
  RetailDashbard = "/retail/dashboard",
  RetailStocks = "/retail/dashboard/stock",
  RetailCustomerAnalysis = "/retail/dashboard/customer-analysis",
  RetailReportSummary = "/retail/report",
  RetailReportStocks = "/retail/report/stock-shelf-management",
  RetailReportCustomerAnalysis = "/retail/report/customer-analysis",
  WASTEDASHBOARDCTMLIVEOVERVIEW = "/wastemanagement/dashboard/liveOverView",
  WASTEDASHBOARDLITTERBIN = "/wastemanagement/dashboard/bin",
}
